/**
 * Widget Analytics Service
 * Tracks events for embeddable widget
 */
export const widgetAnalyticsService = {
  /**
   * Initialize Google Analytics
   * @param {string} ga4Id - GA4 Measurement ID
   */
  init(ga4Id) {
    if (!ga4Id || typeof window === 'undefined') return;

    // Load GA4 script if not already loaded
    if (!window.gtag) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
      document.head?.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function(...args) {
        window.dataLayer?.push(...args);
      };
      window.gtag('js', new Date());
      window.gtag('config', ga4Id);
    }
  },

  /**
   * Track catalog view event
   * @param {string} catalogId - Catalog ID
   * @param {string} catalogTitle - Catalog title
   * @param {string} companyId - Company ID
   */
  trackCatalogView(catalogId, catalogTitle, companyId) {
    if (typeof window.gtag === 'undefined') return;

    window.gtag('event', 'catalog_view', {
      catalog_id: catalogId,
      catalog_title: catalogTitle,
      company_id: companyId,
      embed_mode: true,
      referrer: document.referrer || 'direct',
      timestamp: new Date()?.toISOString()
    });
  },

  /**
   * Track page view event
   * @param {string} catalogId - Catalog ID
   * @param {number} pageNumber - Page number
   * @param {string} companyId - Company ID
   */
  trackPageView(catalogId, pageNumber, companyId) {
    if (typeof window.gtag === 'undefined') return;

    window.gtag('event', 'page_view', {
      catalog_id: catalogId,
      page_number: pageNumber,
      company_id: companyId,
      embed_mode: true,
      referrer: document.referrer || 'direct',
      timestamp: new Date()?.toISOString()
    });
  },

  /**
   * Track hotspot click event
   * @param {string} catalogId - Catalog ID
   * @param {number} pageNumber - Page number
   * @param {string} hotspotType - Hotspot type
   * @param {string} hotspotId - Hotspot ID
   * @param {string} companyId - Company ID
   */
  trackHotspotClick(catalogId, pageNumber, hotspotType, hotspotId, companyId) {
    if (typeof window.gtag === 'undefined') return;

    window.gtag('event', 'hotspot_click', {
      catalog_id: catalogId,
      page_number: pageNumber,
      hotspot_type: hotspotType,
      hotspot_id: hotspotId,
      company_id: companyId,
      embed_mode: true,
      referrer: document.referrer || 'direct',
      timestamp: new Date()?.toISOString()
    });
  },

  /**
   * Track buy button click event
   * @param {string} catalogId - Catalog ID
   * @param {number} pageNumber - Page number
   * @param {string} hotspotId - Hotspot ID
   * @param {string} sku - Product SKU
   * @param {number} quantity - Product quantity
   * @param {string} companyId - Company ID
   */
  trackBuyClick(catalogId, pageNumber, hotspotId, sku, quantity, companyId) {
    if (typeof window.gtag === 'undefined') return;

    window.gtag('event', 'buy_click', {
      catalog_id: catalogId,
      page_number: pageNumber,
      hotspot_id: hotspotId,
      product_sku: sku,
      quantity: quantity,
      company_id: companyId,
      embed_mode: true,
      referrer: document.referrer || 'direct',
      timestamp: new Date()?.toISOString()
    });

    // Also track as e-commerce event
    window.gtag('event', 'add_to_cart', {
      currency: 'USD',
      value: 0,
      items: [
        {
          item_id: sku,
          item_name: sku,
          quantity: quantity
        }
      ]
    });
  }
};